/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step3_BodyInputs */

const es_landing_step3_body = /** @type {(inputs: Landing_Step3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presentamos el cambio de uso, el despacho y el enrole ante la autoridad marítima. Tú no tocas un papel.`)
};

const gl_landing_step3_body = /** @type {(inputs: Landing_Step3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presentamos o cambio de uso, o despacho e o enrolamento ante a autoridade marítima. Ti non tocas un papel.`)
};

const en_landing_step3_body = /** @type {(inputs: Landing_Step3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We file the change of use, dispatch and enrolment with the maritime authority. You do not touch a single form.`)
};

/**
* | output |
* | --- |
* | "We file the change of use, dispatch and enrolment with the maritime authority. You do not touch a single form." |
*
* @param {Landing_Step3_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_step3_body = /** @type {((inputs?: Landing_Step3_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step3_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_step3_body(inputs)
	if (locale === "en") return en_landing_step3_body(inputs)
	return es_landing_step3_body(inputs)
});